// ─────────────────────────────────────────────
// storage.ts
// Persists sessionId to localStorage so the user
// continues the same session after page refresh.
// Key is scoped per tenant+domain so multiple
// widgets on different sites don't collide.
// ─────────────────────────────────────────────

const buildKey = (tenantSlug: string, domainId: string): string =>
  `dirayah:session:${tenantSlug}:${domainId}`

export const storage = {
  // Save current sessionId for this tenant+domain
  saveSessionId(tenantSlug: string, domainId: string, sessionId: string): void {
    try {
      localStorage.setItem(buildKey(tenantSlug, domainId), sessionId)
    } catch {
      // localStorage unavailable (private browsing, storage quota) — silent fail
    }
  },

  // Load persisted sessionId — null if not found or storage unavailable
  loadSessionId(tenantSlug: string, domainId: string): string | null {
    try {
      return localStorage.getItem(buildKey(tenantSlug, domainId))
    } catch {
      return null
    }
  },

  // Clear session — called when user starts a new chat
  clearSessionId(tenantSlug: string, domainId: string): void {
    try {
      localStorage.removeItem(buildKey(tenantSlug, domainId))
    } catch {
      // Silent fail
    }
  },
}